import { openkit } from "../../library/database";

export const searchRestaurants = async (info) => {
  try {
    const query = {
      type: "restaurant",
      name: info.name,
      villages: info.villages,
      people: info.restaurant.people,
      date: info.restaurant.date,
      time: info.restaurant.time,
      quantity: 1,
      immediateConfirmation: info.immediateConfirmation,
    };
    const resp = await openkit.custom.execute(
      "post",
      "search-restaurants",
      null,
      {
        query,
      }
    );
    return resp;
  } catch (error) {
    console.log("error :>> ", error);
  }
};
